define('LoyaltyPrice.Helper', [
	'underscore',
	'Utils'
], function LoyaltyPriceHelper(
	_,
	Utils
) {
	'use strict';

	return {
		getLoyaltyEnable: function getLoyaltyEnable(profile) {
			var enableLoyaltyField = _.findWhere(profile.get('customfields'), { name: 'custentity_loyalty_enabled' });
			return enableLoyaltyField && enableLoyaltyField.value === 'T';
		},

		customerIsLoggedInAnLoyaltyEnabled: function customerIsLoggedInAnLoyaltyEnabled(profile) {
			return profile.get('isLoggedIn') === 'T' && this.getLoyaltyEnable(profile);
		},

		resolveStorePriceForItem: function resolveStorePriceForItem(itemModel, profile) {
			var store = profile.get('store');
			var field = store && _.isFunction(store.get) ? store.get('priceField') : store && store.priceField;
			return field ? itemModel[field.toLowerCase()] : undefined;
		},

		resolveRegularPriceForItem: function resolveRegularPriceForItem(itemModel, profile) {
			var store = profile.get('store');
			var field = store && _.isFunction(store.get) ? store.get('retailField') : store && store.retailField;
			return field ? itemModel[field.toLowerCase()] : undefined;
		},

		isFromSearchSpring: function isisFromSearchSpring(itemModel) {
			return !!itemModel.intellisuggestData;
		},

		resolvePriceDataFromSearchSpringItem: function resolvePriceDataFromSearchSpringItem(itemModel, profile) {
			var searchSpringLoyaltyPrice = 'custitem_aws_loyaltyprice_stored';
			var store = profile.get('store');
			var field = store && _.isFunction(store.get) ? store.get('priceField') : store && store.priceField;
			return {
				loyaltyPrice: parseFloat(itemModel[searchSpringLoyaltyPrice]),
				storePrice: field ? itemModel[field.toLowerCase()] : undefined,
				regularPrice: parseFloat(itemModel.msrp)
			};
		},

		resolvePriceDataFromItem: function resolvePriceDataFromItem(itemModel, profile) {
			var loyaltyPriceField = 'custitem_aws_loyaltyprice_stored';
			return {
				loyaltyPrice: parseFloat(itemModel[loyaltyPriceField]),
				storePrice: this.resolveStorePriceForItem(itemModel, profile),
				regularPrice: this.resolveRegularPriceForItem(itemModel, profile)
			};
		},

		getContextForPriceView: function getContextForPriceView(itemModel, profile) {
			var context;
			var isLoggedId;
			var priceData = this.isFromSearchSpring(itemModel)
				? this.resolvePriceDataFromSearchSpringItem(itemModel, profile)
				: this.resolvePriceDataFromItem(itemModel, profile);
			var priceDataFormatted = {};
			var customerIsLoggedInAnLoyaltyEnabled = this.customerIsLoggedInAnLoyaltyEnabled(profile);
			_.each(_.keys(priceData), function eachK(k) {
				priceDataFormatted[k + 'Formatted'] = Utils.formatCurrency(priceData[k]);
			});
			isLoggedId = { isLoggedId: profile.get('isLoggedIn') === 'T' };
			context = _.extend({}, isLoggedId, priceData, priceDataFormatted);
			context.showLoyalty = _.isNumber(context.loyaltyPrice) && context.loyaltyPrice < context.storePrice;
			context.strikethroughStorePrice = customerIsLoggedInAnLoyaltyEnabled && context.showLoyalty;
			context.showLoyaltyPriceFirts = context.showLoyalty && customerIsLoggedInAnLoyaltyEnabled;
			context.showRegularPrice = context.regularPrice && context.regularPrice > context.storePrice;
			return context;
		}

	};
});
